// Google Analytics 4 (gtag.js), loaded only when a Measurement ID is
// configured. SPA-aware: initial config suppresses the automatic page_view;
// RouteTracker in App.js sends one for every route change instead.
export const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const CONSENT_KEY = 'mementa_cookie_consent';

export function getStoredConsent() {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY));
  } catch {
    return null;
  }
}

export function setAnalyticsConsent(analytics) {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({
      v: 1,
      analytics: !!analytics,
      ts: new Date().toISOString(),
    }));
  } catch { /* private mode */ }
  // If GA already loaded this session and consent is revoked, disable it.
  if (GA_ID && typeof window !== 'undefined') {
    window[`ga-disable-${GA_ID}`] = !analytics;
  }
}

export function hasAnalyticsConsent() {
  const c = getStoredConsent();
  return !!(c && c.analytics);
}

let initialized = false;

export function initGA() {
  if (!GA_ID || initialized || typeof window === 'undefined') return;
  if (!hasAnalyticsConsent()) return;
  initialized = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
